// The states of a logistics sheet and of its shipments, as the API names them (common/logistics): every component reads a state through
// these lists and predicates, never through a literal, so that a new state changes them here only. A status they do not know, or none, is
// none of them.

// A sheet is in preparation until the coordinator validates it (Validate sheet), then ready for processing, its lines locked; the
// warehouse's processing makes it ready to be shipped (Undo processing brings it back) until its main shipment leaves; Reopen sheet brings
// a sheet ready for processing back in preparation, and so does the main shipment's cancellation. A sheet with nothing to send from MPG is
// validated without a shipment instead (D12): final, locked, waiting for nothing; Reopen sheet brings it back in preparation.
export const SHEET_STATES = Object.freeze(["inPreparation", "readyForProcessing", "readyToShip", "shipped", "noShipment"])
// The sheets whose goods have not left yet.
export const AWAITING_SHEET_STATES = Object.freeze(["inPreparation", "readyForProcessing", "readyToShip"])
// The sheets whose lines, delivery and competitions still change directly.
export const EDITABLE_SHEET_STATES = Object.freeze(["inPreparation"])
// The validated sheets whose main shipment the warehouse still processes.
export const PROCESSING_SHEET_STATES = Object.freeze(["readyForProcessing"])
// The sheets whose main shipment the warehouse processed: it waits for the courier.
export const READY_SHEET_STATES = Object.freeze(["readyToShip"])
// The validated sheets whose main shipment is still at the warehouse, processed or not: its AWB still changes.
export const AT_WAREHOUSE_SHEET_STATES = Object.freeze([...PROCESSING_SHEET_STATES, ...READY_SHEET_STATES])
// The validated sheets without a shipment: the club provides every product.
export const WITHOUT_SHIPMENT_SHEET_STATES = Object.freeze(["noShipment"])
export const sheetShipped = status => status === "shipped"
export const sheetAwaitsGoods = status => AWAITING_SHEET_STATES.includes(status)
export const sheetEditable = status => EDITABLE_SHEET_STATES.includes(status)
export const sheetInProcessing = status => PROCESSING_SHEET_STATES.includes(status)
export const sheetReadyToShip = status => READY_SHEET_STATES.includes(status)
export const sheetAtWarehouse = status => AT_WAREHOUSE_SHEET_STATES.includes(status)
export const sheetWithoutShipment = status => WITHOUT_SHIPMENT_SHEET_STATES.includes(status)

// A shipment, the main one or a supplementary one, is in preparation until processed, then ready to be shipped, then shipped; a cancelled
// one is in preparation again, with its cancellation. The main shipment's follows its sheet's.
export const SHIPMENT_STATES = Object.freeze(["inPreparation", "readyToShip", "shipped"])
// The shipments whose goods have not left yet.
export const AWAITING_SHIPMENT_STATES = Object.freeze(["inPreparation", "readyToShip"])
// The shipments whose delivery, weight and AWB generation still change directly.
export const EDITABLE_SHIPMENT_STATES = Object.freeze(["inPreparation"])
// The shipments the warehouse processed, waiting for the courier.
export const READY_SHIPMENT_STATES = Object.freeze(["readyToShip"])
// The shipments that have left.
export const SHIPPED_SHIPMENT_STATES = Object.freeze(["shipped"])
export const shipmentShipped = status => SHIPPED_SHIPMENT_STATES.includes(status)
export const shipmentReadyToShip = status => READY_SHIPMENT_STATES.includes(status)
export const shipmentAwaitsGoods = status => AWAITING_SHIPMENT_STATES.includes(status)
export const shipmentEditable = status => EDITABLE_SHIPMENT_STATES.includes(status)
